export { default as DisplaySettingsMainPanel } from './DisplaySettingsMainPanel';
